import { Data2, newId } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useSystemStateHooks } from '../../system'
import { Lot, LotAttributes } from '../state/types'

export const useLotBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildLot = (data: Data2) => {
        const {
            id = newId(),
            code,
            productId,
            attributes
        } = data

        const lot: Lot = {
            companyId: companyId!,
            id: id! as string,
            code: code! as string,
            productId: productId! as string,
            attributes: attributes as O<LotAttributes>
        }

        return lot
    }

    return {
        buildLot
    }
}
